// Base Url:- https://api.aktivolabs.com/
// Graphql APIs
// 1. Exercise
// 2. Sedentary
// 3. Light activity
// 4. Sleep
// 5. Steps
// Endpoint: POST {base-url}/graphql/user/{userId}

// Note:
// 1. refDate - 2022-01-01 data should be displayed on 2nd Jan 2022.
// 2. All 3 PA values are in seconds.

// Mapping for the 4 PA value with the UI is as follows,
// Physical Activity     Value from API
// 1 Exercise            mpa + vpa
// 2 Light Activity      lipa
// 3 Sedentary           sb

import { gql } from "graphql-request";

// For vscode syntax highlighting
// https://stackoverflow.com/a/65714939
// const gql = String.raw;

export const scoreStats = gql`
  query scoreStats($startDate: String!, $endDate: String!) {
    scoreStats(from: $startDate, to: $endDate) {
      stats {
        refDate
        actualPas {
          mpa
          vpa
          lipa
          sb
        }
        impact {
          mvpa
          lipa
          sb
          sleep
        }
        score
      }
    }
  }
`;

export const sleepStats = gql`
  query sleepStats($startDate: String!, $endDate: String!) {
    sleepStats(from: $startDate, to: $endDate) {
      stats {
        refDate
        total {
          timeInBed
        }
        impact
      }
    }
  }
`;

export const stepsStats = gql`
  query stepsStats($startDate: String!, $endDate: String!) {
    stepsStats(from: $startDate, to: $endDate) {
      stats {
        refDate
        value
      }
    }
  }
`;

export const allStats = gql`
  query allStats($startDate: String!, $endDate: String!) {
    scoreStats(from: $startDate, to: $endDate) {
      stats {
        refDate
        actualPas {
          mpa
          vpa
          lipa
          sb
        }
        impact {
          mvpa
          lipa
          sb
          sleep
        }
        score
      }
    }
    sleepStats(from: $startDate, to: $endDate) {
      stats {
        refDate
        total {
          timeInBed
        }
        impact
      }
    }
    stepsStats(from: $startDate, to: $endDate) {
      stats {
        refDate
        value
      }
    }
  }
`;
